import React from 'react';
import PropTypes from 'prop-types';
import injectSheet, { ThemeProvider } from 'react-jss';
import createBreakpoints from './createBreakpoints';
import typography, { loadFont } from './typography';
import createTransitions from './createTransitions';
import shadows from './shadows';

const grey = {
  black: '#000',
  white: '#fff',
  text: '#666',
  darkText: '#505050',
  grey: '#9f9f9f',
  transparent: 'rgba(0, 0, 0, 0)',
  fullBlack: 'rgba(0, 0, 0, 1)',
  darkBlack: 'rgba(0, 0, 0, 0.87)',
  lightBlack: 'rgba(0, 0, 0, 0.54)',
  minBlack: 'rgba(0, 0, 0, 0.26)',
  faintBlack: 'rgba(0, 0, 0, 0.12)',
  fullWhite: 'rgba(255, 255, 255, 1)',
  darkWhite: 'rgba(255, 255, 255, 0.87)',
  lightWhite: 'rgba(255, 255, 255, 0.54)',
  700: 'rgba(0, 0, 0, 0.54)',
};

export const defaultTheme = {
  shadows,
  typography,
  breakpoints: createBreakpoints(),
  transitions: createTransitions(),
  palette: {
    grey,
    common: grey,
    primary: {
      500: '#0094DA',
    },
    secondary: grey,
    error: {
      500: '#FC4D4A',
    },
    warning: grey,
    success: {
      300: '#afd87a',
      500: '#8CC63F',
    },
    background: {
      default: '#fafafa',
      paper: '#fff',
      appBar: '#f5f5f5',
      contentFrame: '#eee',
    },
    action: {
      active: 'rgba(0, 0, 0, 0.54)',
      hover: 'rgba(0, 0, 0, 0.08)',
      selected: 'rgba(0, 0, 0, 0.14)',
      disabled: 'rgba(0, 0, 0, 0.26)',
      disabledBackground: 'rgba(0, 0, 0, 0.12)',
    },
  },
  opacity: {
    hover: 0.95,
    disabled: 0.3,
  },
  spacing: {
    unit: 8,
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 40,
    xlarge: 64,
  },
  border: {
    small: '1px solid #BBB',
    medium: '2px solid #BBB',
  },
  zIndex: {
    mobileStepper: 1000,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
  },
};

function SiteThemeProvider({ theme, site, children }) {
  loadFont(site);
  return <ThemeProvider theme={theme || defaultTheme}>{children}</ThemeProvider>;
}

SiteThemeProvider.propTypes = {
  site: PropTypes.object,
  theme: PropTypes.object,
  children: PropTypes.node,
};

SiteThemeProvider.defaultProps = {
  site: { styles: {} },
  theme: null,
  children: null,
};

const stylesheet = {
  '@global': {
    body: {
      boxSizing: 'border-box',
    },
    '*': {
      boxSizing: 'inherit',
    },
    svg: {
      fill: 'currentColor',
    },
  },
};

export default injectSheet(stylesheet)(SiteThemeProvider);



// WEBPACK FOOTER //
// ./src/site-render/src/SiteThemeProvider/SiteThemeProvider.js